import React, { useEffect, useState } from "react";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { useAddOneDayDataMutation } from "src/services/CourseServices";
import SingleDayLayout from "./SingleDayLayout";
import { AddDayDetailsFormValues } from "src/models/AddDayDetails.model";
import { showToast } from "src/utils/showToaster";
import { useGetSingleDayDataQuery } from "src/services/BatchServices";
import { useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";



const SingleDayLayoutWrapper = () => {
  const [addDaysData] = useAddOneDayDataMutation(); 

  const [dayData , setDayData] = useState<any>({})

  const {  dayId } = useParams();


  const { data, isLoading, isFetching } = useGetSingleDayDataQuery(dayId);

  useEffect(()=>{
    setDayData(data?.data?.[0]) 
  },[data, isLoading, isFetching])


  // Form Initial Values
  const initialValues: AddDayDetailsFormValues = {
    notes:  dayData?.day?.notes || '',
    day: dayData?.day?.day || '' ,
    remark : dayData?.day?.remark || '' ,
    exampleAndScript:  dayData?.day?.exampleAndScript || '',
    resources: dayData?.day?.resources?.[0] !== ''
    ? dayData?.day?.resources?.map((el: any) => {
        return {
          name: el?.resourceName,
        };
      })
    : [
        {
          name: "",
        },
      ],
  };

  // Validation Schema
  const validationSchema = object().shape({
    notes: string().required("Please enter notes"),
    exampleAndScript: string().required("Please enter exampleAndScript"),
  });

  // Handle Submit
  const handleSubmit = (
    values: AddDayDetailsFormValues,
    { setSubmitting, resetForm }: FormikHelpers<AddDayDetailsFormValues>
  ) => {
    const formattedValues = {
      notes: values?.notes,
      planId:dayData?._id,
      day: values?.day ||'',
      remark: values?.remark ||'',
      exampleAndScript: values?.exampleAndScript,
      resources: values?.resources?.map((el: any) => {
        return {
          resourceName: el?.name,
        };
      }),
    };
    addDaysData({
      dayId:dayId,
      body: formattedValues,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formikProps) => (
        <Form>
             {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
          <SingleDayLayout formikProps={formikProps} />
        </Form>
      )}
    </Formik>
  );
};

export default SingleDayLayoutWrapper;
